<body id="dark" class="pt-20" style="padding-top:120px; min-height: 100vh; ">

  <div class="col-md-2 mx-3 mt-4 text-start">
    <h5 class="text-color-theme">{{"global-market"|translate}}</h5>
  </div>

  <div class="demo-wrap">
    <div class="demo-content">
      <div class="row px-2 pt-2">
        <div class="col-md-5" style="opacity: 0.9;">
          <div id="tradingview_bac65"></div>
        </div>
        <div class="col-md-7 text-center" style="align-self: center;">
          <div *ngFor="let index of majorIndexes" style="display: inline-block;"
            (click)="renderIndexData(index.Symbol)">
            <div style=" font-size: small;" class="card demo-wrap-card-bg text-color-theme">
              <div class="p-1">
                <div class="d-flex justify-content-between">
                  <div class="font-weight-bold p-1"
                    style="text-overflow:ellipsis !important;font-size: 14px;white-space: nowrap;overflow: hidden;">
                    {{index.Symbol}}
                  </div>
                  <div style="font-size: 15px;" class="p-1" [ngClass]="index.ChangePer>0? 'green' : 'red'">
                    {{index.Change | number : '1.2-2'}} ({{index.ChangePer | number : '1.2-2'}}%)
                    <i class="ion-md-trending-up" *ngIf="index.ChangePer>0"></i>
                    <i class="ion-md-trending-down" *ngIf="index.ChangePer<0"></i>
                  </div>
                </div>
                <div class="d-flex justify-content-between" style="max-width: 100%;">
                  <div class="p-1"
                    style="text-overflow:ellipsis !important;font-size:14px;white-space: nowrap;overflow: hidden;">
                    {{index.Name}}
                  </div>
                  <div class="p-1 demo-wrap-card-text" style=" font-size: 15px;">
                    {{index.Close | number}}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let index of middleEastIndexes" style="display: inline-block; cursor:default;">
            <div style=" font-size: small;" class="card demo-wrap-card-bg text-color-theme " *ngIf="index.Indexes[0]?.ChangePer">
              <div class="p-1">
                <div class="d-flex justify-content-between">
                  <div class="p-1 font-weight-bold"
                    style="text-overflow:ellipsis !important;font-size: 14px;white-space: nowrap;overflow: hidden;">
                    {{index.ENName}}
                  </div>
                  <div style="font-size: 15px;" class="p-1" [ngClass]="index.Indexes[0]?.ChangePer>0? 'green' : 'red'">
                    {{index.Indexes[0]?.Change | number : '1.2-2'}} ({{index.Indexes[0]?.ChangePer | number :
                    '1.2-2'}}%)
                    <i class="ion-md-trending-up" *ngIf="index.Indexes[0]?.ChangePer>0"></i>
                    <i class="ion-md-trending-down" *ngIf="index.Indexes[0]?.ChangePer<0"></i>
                  </div>
                </div>
                <div class="d-flex justify-content-between" style="max-width: 100%;">
                  <div class="p-1"
                    style="text-overflow:ellipsis !important;font-size:14px; white-space: nowrap;overflow: hidden;">
                    {{index.Indexes[0]?.Name}}
                  </div>
                  <div class="p-1 demo-wrap-card-text" style=" font-size: 15px;">
                    {{index.Indexes[0]?.Close | number}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <br>
  <div style="border-radius: 5px;" class="demo-wrap-card-bg ticker-bg ticker-border">
    <ngx-marquee style=" direction: ltr;" pauseOnHover="true" [duration]="'600s'">
      <div *ngFor="let item of news" style="display: inline-block; cursor: pointer;" class="p-1">
        <div class="text-color-theme px-2"><span
            class="news-date">{{item.DATE_STAMP|date:'mediumTime'}}</span>{{item.ARB_HEADING}}</div>
      </div>
    </ngx-marquee>
  </div>

  <div class="col-md-2 mx-3 mt-4">
    <h5 class="text-color-theme">{{"metals"|translate}}</h5>
  </div>
  <div class="row mb-2 px-5 mt-3" *ngIf="metalsData">
    <div *ngFor="let rate of metalsData[0].Indexes" class="col-md-3">
      <div style="font-size: small;" class="metal-card demo-wrap-card-bg text-color-theme ">
        <div class="p-1">
          <div class="d-flex justify-content-between px-1">
            <div class="p-1 font-weight-bold text-color-theme"
              style="text-overflow:ellipsis !important;font-size: 16px;white-space: nowrap;overflow: hidden;">
              <span [ngStyle]="{'color':metalColor(rate.Symbol)}">{{rate.Symbol}}</span> <small
                class="text-muted px-1">{{(rate.Name)}}</small>
            </div>
            <div style="font-size: 15px;" class="p-1" [ngClass]="rate.ChangePer>0? 'green' : 'red'">
              {{rate.Change | number : '1.2-2'}} ({{rate.ChangePer | number : '1.2-2'}}%)
              <i class="ion-md-trending-up" *ngIf="rate.ChangePer>0"></i>
              <i class="ion-md-trending-down" *ngIf="rate.ChangePer<0"></i>
            </div>
          </div>
          <div class="d-flex justify-content-between px-1" style="max-width: 100%;">
            <div class="p-1"
              style="text-overflow:ellipsis !important;font-size:14px; white-space: nowrap;overflow: hidden;">
              <span style="color: #0094b9; font-weight: 500;">{{rate.Last_Time|date:'MMM d, yy, h:mm:ss a' }}</span>
            </div>
            <div class="p-1 demo-wrap-card-text" style=" font-size: 15px;">
              {{rate.Close | number}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 mx-3 mt-4">
    <h5 class="text-color-theme">{{"gdr"|translate}}</h5>
  </div>
  <div class="row mb-2 px-5 mt-3 justify-content-center" *ngIf="gdrData">
    <div *ngFor="let index of gdrData" class="col-2 py-2">
      <div style=" font-size: small;" class="metal-card demo-wrap-card-bg ">
        <div class="p-1">
          <div class="d-flex justify-content-between">
            <div class="p-1 font-weight-bold text-color-theme"
              style="text-overflow:ellipsis !important;font-size: 14px;white-space: nowrap;overflow: hidden;">
              {{index.Symbol}}
            </div>
            <div style="font-size: 15px;" class="p-1" [ngClass]="index.ChangePer>0? 'green' : 'red'">
              {{index.Change | number : '1.2-2'}} ({{index.ChangePer | number : '1.2-2'}}%)
              <i class="ion-md-trending-up" *ngIf="index.ChangePer>0"></i>
              <i class="ion-md-trending-down" *ngIf="index.ChangePer<0"></i>
            </div>
          </div>
          <div class="d-flex justify-content-between" style="max-width: 100%;">
            <div class="p-1 text-color-theme"
              style="text-overflow:ellipsis !important;font-size:14px; white-space: nowrap;overflow: hidden;">
              {{(translate.currentLang=='en')?index.Name:index.Name_AR}}
            </div>
            <div class="p-1 demo-wrap-card-text" style=" font-size: 15px;">
              {{index.Close | number}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-2 mx-3 mt-4">
    <h5 class="text-color-theme">{{"exchange-rates"|translate}}</h5>
  </div>
  <div class="mb-5 px-5" style="direction: ltr !important;">
    <ngx-slick-carousel class="carousel" #slickModal="slick-carousel" [config]="slideConfig">
      <div *ngFor="let rate of exchangeRates" ngxSlickItem class="slide  card-margin">
        <div style="font-size: small;" class="card demo-wrap-card-bg text-color-theme">
          <div class="p-1">
            <div class="d-flex justify-content-between">
              <div class="p-1 font-weight-bold"
                style="text-overflow:ellipsis !important;font-size: 16px;white-space: nowrap;overflow: hidden;">
                {{rate.Currency_Name}}
              </div>
              <div style="font-size: 15px;" class="p-1">
                <span style="color: #0094b9; font-weight: 500;">{{rate.Last_Refreshed|date:'MMM d, y, h:mm:ss a'
                  }}</span>
              </div>
            </div>
            <div class="d-flex justify-content-between px-1" style="max-width: 100%;">
              <div class="p-1 demo-wrap-card-text" >
                <span class="green px-1">{{"buy"|translate}}</span><span
                  style="font-size: 15px;">{{rate.Buy_Rate}}</span>
              </div>
              <div class="p-1 demo-wrap-card-text" >
                <span class="red px-1">{{"sell"|translate}}</span><span style="font-size: 15px;">
                  {{rate.Sell_Rate}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </ngx-slick-carousel>
  </div>

  <div class="row mx-4">
    <div class='col-12'>
      <div class="tradingview-widget-container">
        <div class="tradingview-widget-container__widget"></div>
        <div #tradingview></div>
      </div>
    </div>
  </div>



  <!-- <div class="row mx-4">
    <div *ngFor="let rate of exchangeRates" style="display: inline-block; cursor:default;">
      <div style="background-color: #1c1c1c; font-size: small;" class="card">
        <div class="p-1">
          <div class="d-flex justify-content-between">
            <div class="p-1 font-weight-bold" style="text-overflow:ellipsis !important;color:rgb(190, 190, 190);font-size: 16px;white-space: nowrap;overflow: hidden;">
              {{rate.Currency_Name}}
            </div>
            <div style="font-size: 15px;" class="p-1">
              <span style="color: #0094b9; font-weight: 500;">{{rate.Last_Refreshed|date:'MMM d, y, h:mm:ss a' }}</span>
            </div>
          </div>
          <div class="d-flex justify-content-between px-1" style="max-width: 100%;">
            <div class="p-1 demo-wrap-card-text">
              <span class="green px-1">{{"buy"|translate}}</span><span style="font-size: 15px;">{{rate.Buy_Rate}}</span>
            </div>
            <div class="p-1 demo-wrap-card-text">
              <span class="red px-1">{{"sell"|translate}}</span><span style="font-size: 15px;"> {{rate.Sell_Rate}}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div> -->

</body>
